import { IFilterItem } from '../../models';
import {
  ActionIcon,
  Button,
  createStyles,
  Group,
  Popover,
  Select,
  Text,
  useMantineTheme,
} from '@mantine/core';
import { useState, useEffect } from 'react';
import { Plus } from 'tabler-icons-react';

const useStyles = createStyles((theme, _params) => {
  return {
    button: {
      paddingLeft: theme.spacing.xs,
      paddingRight: `calc(${theme.spacing.xs} / 2)`,
      paddingTop: 0,
      paddingBottom: 0,
      borderRadius: theme.radius.lg,
      height: 'fit-content',
    },

    text: {
      userSelect: 'none',
      fontSize: theme.fontSizes.xs,
      marginBottom: 1,
    },

    icon: {
      marginLeft: 3,
      strokeWidth: 3,
    },

    itemButton: {
      height: `calc(${theme.spacing.lg} * 2)`,
      paddingLeft: theme.spacing.xs,
      paddingRight: theme.spacing.xs,

      '&:hover': {
        background: theme.colors.blue[0],
        borderBottomStyle: 'solid',
        borderBottomColor: theme.colors.gray[1],
        borderTopStyle: 'solid',
        borderTopColor: theme.colors.gray[1],
      },
    },

    disabledButton: {
      color: theme.colors.gray[5],

      '&:hover': {
        background: theme.colors.gray[0],
      },
    },
  };
});

interface AddFilterButtonProps {
  filterOptions: IFilterItem[];
  selectedFilters?: IFilterItem[];
  onFilterSelected: (newFilter: IFilterItem) => void;
}

export const AddFilterButton = (props: AddFilterButtonProps) => {
  const theme = useMantineTheme();
  const { classes } = useStyles();

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>('');
  const [selectedFilterItem, setSelectedFilterItem] = useState<IFilterItem | null>(null);

  useEffect(() => {
    setSearchValue('');
    setSelectedFilterItem(null);
  }, [isOpen]);

  return (
    <Group>
      <Popover
        opened={isOpen}
        onChange={setIsOpen}
        transitionProps={{ duration: 300, transition: 'scale', timingFunction: 'ease' }}
        withinPortal
        closeOnClickOutside
      >
        <Popover.Target>
          <Button className={classes.button} onClick={() => setIsOpen((a) => !a)}>
            <Text className={classes.text}>Add Filter</Text>
            <Plus size={12} className={classes.icon} />
          </Button>
        </Popover.Target>
        <Popover.Dropdown p={0}>
          <Group spacing={5} p={5}>
            <Select
              searchable
              searchValue={searchValue}
              onSearchChange={(a) => setSearchValue(a)}
              label="Select an Equipment Type"
              placeholder="Equipment Type"
              data={props.filterOptions
                .map((a) => ({ value: a.id, label: a.label }))
                .filter((a) => !props.selectedFilters?.find((b) => a.value === b.id))}
              maxDropdownHeight={200}
              value={selectedFilterItem?.id}
              onChange={(a) =>
                setSelectedFilterItem(props.filterOptions.find((b) => a === b.id) ?? null)
              }
            />
            <ActionIcon
              variant="subtle"
              mt={25}
              style={{ color: theme.colors.blue[5] }}
              onClick={() => {
                if (selectedFilterItem !== null) {
                  props.onFilterSelected(selectedFilterItem);
                  setIsOpen(false);
                }
              }}
            >
              <Plus />
            </ActionIcon>
          </Group>
        </Popover.Dropdown>
      </Popover>
    </Group>
  );
};
